const UUID_RE = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';

export interface LoyaltyJoinRoute {
  clientId: string;
  linkSlug?: string;
}

/** Public customer signup URL — always at site root, never under /admin. */
export function buildLoyaltyJoinUrl(clientId: string, linkSlug?: string): string {
  const base =
    (import.meta.env.VITE_LOYALTY_JOIN_ORIGIN as string | undefined)?.replace(/\/$/, '') ||
    (typeof window !== 'undefined' ? window.location.origin : '');
  const slug = linkSlug?.trim();
  return slug ? `${base}/join/${clientId}/${slug}` : `${base}/join/${clientId}`;
}

/** True when the current page is the public loyalty signup (not the admin dashboard). */
export function isLoyaltyJoinPage(): boolean {
  return getLoyaltyJoinRoute() !== null;
}

/** Client + optional link slug from `/join/{uuid}/{slug}` or legacy hash. */
export function getLoyaltyJoinRoute(): LoyaltyJoinRoute | null {
  if (typeof window === 'undefined') return null;

  const pathMatch = window.location.pathname.match(
    new RegExp(`^/join/(${UUID_RE})(?:/([a-z0-9-]+))?$`, 'i'),
  );
  if (pathMatch?.[1]) {
    return { clientId: pathMatch[1], linkSlug: pathMatch[2]?.toLowerCase() };
  }

  const hash = window.location.hash.replace(/^#\//, '').split('?')[0] ?? '';
  const hashMatch = hash.match(new RegExp(`^loyalty/join/(${UUID_RE})$`, 'i'));
  if (hashMatch?.[1]) return { clientId: hashMatch[1] };

  return null;
}

/** @deprecated Use getLoyaltyJoinRoute(). */
export function getLoyaltyJoinClientId(): string | null {
  return getLoyaltyJoinRoute()?.clientId ?? null;
}
